import { useEffect, useMemo, useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { RECENT_CONTRACTS_PERM_CODE } from './recentContractMenuLabel';

export function useRecentContractsMenuMonths(menus) {
  const hasRecentContractsMenu = useMemo(
    () => (menus || []).some((menu) => menu?.permCode === RECENT_CONTRACTS_PERM_CODE),
    [menus],
  );
  const [months, setMonths] = useState(null);

  useEffect(() => {
    let active = true;
    if (!hasRecentContractsMenu) {
      setMonths(null);
      return () => { active = false; };
    }

    apiClient.get('/api/tm/recent-contracts/menu-settings')
      .then((res) => {
        if (!active) return;
        const value = Number(res.data?.months);
        setMonths(res.ok && Number.isInteger(value) && value > 0 ? value : null);
      })
      .catch(() => {
        if (active) setMonths(null);
      });

    return () => { active = false; };
  }, [hasRecentContractsMenu]);

  return months;
}
